(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["salfa-vehicle-filter"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', salfaVehicleFilterInit);
  document.addEventListener('shopify:section:load', salfaVehicleFilterInit);

  function salfaVehicleFilterInit() {
    document.querySelectorAll('[data-salfa-vehicle-filter]').forEach(function (root) {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      var form = root.querySelector('[data-salfa-vehicle-form]');
      var selects = Array.from(root.querySelectorAll('[data-salfa-filter-index]'));

      selects.forEach(function (select, index) {
        select.addEventListener('change', function () {
          selects.slice(index + 1).forEach(function (downstream) {
            downstream.value = '';
          });
          form.submit();
        });
      });

      document.querySelectorAll('[data-filter-param-name*="compatibilidad-marca"], [data-filter-param-name*="compatibilidad-modelo"], [data-filter-param-name*="compatibilidad-anio"], [data-filter-param-name*="compatibilidad-motor"]').forEach(function (nativeFilter) {
        nativeFilter.hidden = true;
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
